import React, {useCallback, useState} from "react";

export const DashboardContext = React.createContext({
  visitorCountData: [],
  chatCountData: [],
  pageViewsData: [],
  setVisitorCountCallback: null,
  setChatCountCallback: null,
  setPageViewsCallback: null,
})

export const DashboardContextProvider = ({children}) => {

  const [visitorCountData, setVisitorCountData] = useState([])
  const [chatCountData, setChatCountData] = useState([])
  const [pageViewsData, setPageViewsData] = useState([])

  const setVisitorCountCallback = useCallback((data) => {
    setVisitorCountData(data)
  }, [])

  const setChatCountCallback = useCallback((data) => {
    setChatCountData(data)
  }, [])

  const setPageViewsCallback = useCallback((data) => {
    setPageViewsData(data)
  }, [])

  return (
    <DashboardContext.Provider value={
      {
        chatCountData,
        visitorCountData,
        pageViewsData,
        setVisitorCountCallback,
        setChatCountCallback,
        setPageViewsCallback
      }
    }>
      {children}
    </DashboardContext.Provider>
  )
}